import lifebuoy from '../../_assets/lifebuoy.svg';
import laptopWithArrow from '../../_assets/laptop-with-arrow.svg';

export const CONFIRM_ICON = {
  lifebuoy,
  'laptop-with-arrow': laptopWithArrow,
};
